export default __webpack_public_path__ + "static/media/upload.4b76038f.svg";